'use client'

import { Alert, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import InfoIcon from '@/assets/icons/info-circle.svg'
import { I18nLink } from '@/i18n/navigation'

import styles from './index.module.css'

interface NotTradableBannerProps {
  symbol: string
}

export default function NotTradableBanner({ symbol }: NotTradableBannerProps) {
  const t = useTranslations('converter')

  return (
    <Alert
      variant="light"
      color="blue"
      icon={<InfoIcon fill="var(--common-white)" />}
      classNames={{
        root: styles.notTradableBannerRoot,
        icon: styles.notTradableBannerIcon,
        message: styles.notTradableBannerMessage,
      }}
    >
      <Text variant="subtitle">
        {t.rich('notTradableDescription', {
          symbol,
          exploreLink: (chunks: React.ReactNode) => (
            <I18nLink href="/price" style={{ color: 'var(--content-active, --common-primary)' }}>
              {chunks}
            </I18nLink>
          ),
        })}
      </Text>
    </Alert>
  )
}
